import sidebarLeft from '../../components/Sidebar/sidebar'
import sidebarTop from '../../components/Sidebar/sidebarTop'

export const sidebar = {
  components: {
    sidebarLeft,
    sidebarTop
  },
  computed: {
    showSidebar() {
      return this.$store.state.sidebar.showSidebar;
    }
  }
};
